import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from "react-redux";


// components
import CategoryPromotionFrom from "./_form";
import CategoryPromotionList from "./_list";
import { showLoader } from "../../../components/loader/loader";
import { showToastCustom } from "../../../components/toast/customToast";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";
import { ButtonNew, ButtonSync } from "../../../components/buttons/buttonsActions";

// labels
import { error, success, updateMsg } from "../../../components/i18n/i18n";

// services
import {categoryPromotionService} from "../../../jwt/_services/promotions/categoryPromotionService";

// actions
import { setForm } from "../../../redux/actions/generalActions/formActions";
import { clearState as clearListState } from "../../../redux/actions/generalActions/listActions";
import { clearState, setApp, setCategory, setLoading, setUdn, setViewMode } from "../../../redux/actions/generalActions/mainActions";


const CategoryPromotion = (props) => {
    const { loading } = props.mainProps

    // Modo de vista: LIST, FORM
    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);

    const syncFirebase = () => {
        props.setLoading(true);
        categoryPromotionService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
                showToastCustom(success, updateMsg);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const createItem = ()  => {
        props.setForm()
        ModalFormContainer(CategoryPromotionFrom, {data: null, Form: CategoryPromotionFrom})
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonSync onClick={syncFirebase}/>
                            <ButtonNew onClick={createItem}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <CategoryPromotionList />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading,
    clearListState
});

export default connect(mapStateToProps, mapActionsToProps)(CategoryPromotion)
